import type { PictogramFragment } from "@/graphql";
import type { IMultiSelectItem } from "@/interfaces";
import type { IFileState } from "@/interfaces";

const toMultiSelectItem = (item: PictogramFragment): IMultiSelectItem => {
  return {
    id: item.id,
    title: item.description || "",
    imageURL: item.source,
  };
};

const toFileState = (images: PictogramFragment[]): IFileState[] => {
  return images.map((image) => {
    return {
      id: image.id.toString(),
      name: image.description?.toString() || "",
      url: image.source,
      size: 0,
      source: "pictogram",
      type: "image",
    };
  });
};

export default {
  toMultiSelectItem,
  toFileState,
};
